import { getApiConfiguration } from 'app/src/msw/companyagreement/api/getApiConfiguration'
import { getCategories } from 'app/src/msw/companyagreement/api/getCategories'
import { getCategory } from 'app/src/msw/companyagreement/api/getCategory'
import { getProduct } from 'app/src/msw/companyagreement/api/getProduct'
import { getProducts } from 'app/src/msw/companyagreement/api/getProducts'
import { postConfirmProposals } from 'app/src/msw/companyagreement/api/postConfirmProposals'
import { postToggleFavourite } from 'app/src/msw/companyagreement/api/postToggleFavourite'

export const companyagreementHandlers = [
  getApiConfiguration,
  getCategories,
  getProducts,
  getProduct,
  postConfirmProposals,
  postToggleFavourite,
  getCategory,
]
